"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoftTissueCondition_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SoftTissueConditionType_1 = require("./SoftTissueConditionType");
var SoftTissueCondition_Factory = /** @class */ (function () {
    function SoftTissueCondition_Factory() {
    }
    SoftTissueCondition_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ConditionType: SoftTissueConditionType_1.SoftTissueConditionType_Factory.CreateIncoming(model.ConditionType),
            Description: model.Description,
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TypeCode: model.TypeCode,
        };
        return result;
    };
    SoftTissueCondition_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ConditionType: SoftTissueConditionType_1.SoftTissueConditionType_Factory.CreateOutgoing(model.ConditionType),
            Description: model.Description,
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TypeCode: model.TypeCode,
        };
        return result;
    };
    return SoftTissueCondition_Factory;
}());
exports.SoftTissueCondition_Factory = SoftTissueCondition_Factory;
